import React from 'react';
import moment from 'moment';

const LicenseTimeline = ({ paymentStatus, applicationDate }) => {
  // Determine payment step status
  const isPaymentComplete = paymentStatus === 'complete' || paymentStatus === 'waived';
  const isPaymentProcessing = paymentStatus === 'pending_confirmation';

  // Determine the label and status for the payment step
  const getPaymentStepConfig = () => {
    if (isPaymentComplete) {
      return { label: 'Payment', status: 'completed' };
    }
    if (isPaymentProcessing) {
      return { label: 'Payment (Processing)', status: 'processing' };
    }
    return { label: 'Payment', status: 'current' };
  };

  const paymentStepConfig = getPaymentStepConfig();

  const steps = [
    {
      id: 'applied',
      label: 'Applied',
      date: applicationDate ? moment(applicationDate).format('D MMM YYYY') : null,
      status: 'completed'  // Always completed if timeline is shown
    },
    {
      id: 'payment',
      label: paymentStepConfig.label,
      status: paymentStepConfig.status
    },
    {
      id: 'review',
      label: 'Under Review',
      status: isPaymentComplete ? 'current' : 'pending'
    }
  ];

  const getStepIcon = (status) => {
    if (status === 'completed') {
      return (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
          <path d="M13.5 4.5L6 12L2.5 8.5" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      );
    }
    if (status === 'processing') {
      return (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" className="spinning">
          <path d="M8 1.5V4" stroke="white" strokeWidth="2" strokeLinecap="round"/>
          <path d="M8 12V14.5" stroke="white" strokeWidth="2" strokeLinecap="round" opacity="0.3"/>
          <path d="M3.05 3.05L4.82 4.82" stroke="white" strokeWidth="2" strokeLinecap="round" opacity="0.7"/>
          <path d="M11.18 11.18L12.95 12.95" stroke="white" strokeWidth="2" strokeLinecap="round" opacity="0.3"/>
          <path d="M1.5 8H4" stroke="white" strokeWidth="2" strokeLinecap="round" opacity="0.5"/>
          <path d="M12 8H14.5" stroke="white" strokeWidth="2" strokeLinecap="round" opacity="0.3"/>
        </svg>
      );
    }
    return null;
  };

  return (
    <div className="progress-card">
      <h3 className="progress-title">Application Progress</h3>

      <div className="progress-timeline">
        {steps.map((step, index) => (
          <React.Fragment key={step.id}>
            {/* Step */}
            <div className={`progress-step progress-step--${step.status}`}>
              <div className="progress-step__marker">
                {getStepIcon(step.status)}
              </div>
              <div className="progress-step__info">
                <span className="progress-step__label">{step.label}</span>
                {step.date && <span className="progress-step__date">{step.date}</span>}
              </div>
            </div>

            {/* Connector line (not after last step) */}
            {index < steps.length - 1 && (
              <div className={`progress-connector ${
                steps[index + 1].status !== 'pending' && steps[index + 1].status !== 'processing' ? 'progress-connector--active' : ''
              }`} />
            )}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

export default LicenseTimeline;
